import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { TextInput } from '../TextInput/TextInput';
import CrossIcon from '@/assets/icons/heroIcons/Cross.svg';
import SearchIcon from '@/assets/icons/heroIcons/Search.svg';
export function SearchInput(props) {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-blue-500"><SearchIcon /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.input.value || $[2] !== props.onClean) {
    t1 = props.input.value !== "" && {
      rightIcon: <button type="button" onClick={props.onClean} aria-label="Clear search" className="p-0"><CrossIcon aria-hidden="true" /></button>
    };
    $[1] = props.input.value;
    $[2] = props.onClean;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <TextInput {...props} leftIcon={t0} {...t1} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}